module.exports = __webpack_public_path__ + "img/raquettePadel.18721044.jpg";